import { makeObservable, observable, action } from 'mobx'

class Comunication {
    constructor(id, title, body, attachments, createdAt, readAt, read) {
        this.id = id
        this.title = title
        this.body = body
        this.attachments = attachments
        this.createdAt = createdAt
        this.read = read
        this.highlight = !read
        this.readAt = readAt
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false

        makeObservable(this, {
            isNewlyAdded: observable,
            isSilentlyUpdated: observable,
            setSilentHighlight: action,
            clearSilentHighlight: action,
        })
    }

    setSilentHighlight({ isNewlyAdded = false, isSilentlyUpdated = false } = {}) {
        this.isNewlyAdded = isNewlyAdded
        this.isSilentlyUpdated = isSilentlyUpdated
    }

    clearSilentHighlight() {
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false
    }

    static fromJson({ id, title, body, attachments, createdAt, readAt, read }) {
        return new Comunication(id, title, body, attachments, createdAt, readAt, read)
    }
}

export default Comunication
